
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { AtenderciudadanoUACRouting } from './atender-ciudadano-UAC-routing.module';
import { AtenderCiudadanoUACComponent } from './atender-ciudadano-UAC.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AtencionCiudadanoUACComponent } from './atencion-ciudadano-UAC.component';
import { VentanillaEsperaUACComponent } from './ventanilla-espera-UAC.component';
import { ConsultaTurnosUACComponent } from './consulta-turnos-UAC.component';
import { UtilService } from 'src/app/shared/services/util.service';
import { TransferirTurnoUACComponent } from './transferir-turno-UAC.component';
import { SeleccionVentanillaComponent } from './seleccion-ventanilla.component';
@NgModule({
    declarations: [
        AtenderCiudadanoUACComponent
        , AtencionCiudadanoUACComponent
        , VentanillaEsperaUACComponent
        , ConsultaTurnosUACComponent
        , TransferirTurnoUACComponent
        , SeleccionVentanillaComponent],
    imports: [
        NgxSpinnerModule,
        AtenderciudadanoUACRouting,
        SharedModule,
        CommonModule
    ],
    entryComponents: [
        AtencionCiudadanoUACComponent
        , VentanillaEsperaUACComponent
        , ConsultaTurnosUACComponent
        , TransferirTurnoUACComponent
        , SeleccionVentanillaComponent]
    , providers: [
        UtilService]
})

export class AtenderCiudadanoUACModule { }
